module.exports = __webpack_public_path__ + "static/make-video-slide3-5a3c62b6db096aede8f86c718bdcfe31.png";